import* as  React from 'react';
import {IUploadVideoComponentProps} from "./IUploadVideoComponentProps";
import {IUploadVideoComponentState} from "./IUploadVideoComponentState";
import MenuComponent from "src/components/menuComponent/MenuComponent";
import HeaderComponent from "src/components/homeHeader/HeaderComponent";
import {toast, ToastContainer} from "react-toastify";
import icon3 from "../../assets/images/Group.svg";
import icon2 from "../../assets/images/ion2.svg";
import {Line} from 'rc-progress';
import Loader from 'react-loader-spinner'
import { WithContext as ReactTags } from 'react-tag-input';
import * as gifshot from 'gifshot'
import {connect } from 'react-redux'
import {Link , withRouter} from 'react-router-dom'
import axios from 'axios';
import MagicDropzone from 'react-magic-dropzone';
import FooterComponent from "src/components/footerComponent/FooterComponent";
import {IUploadGifComponentProps} from "../uploadGifComponent/IUploadGifComponentProps";
import * as gifActions from "../../actions/gifAction";
import MenuLeftemobile from "../menuLeftMobile/MenuLeftemobile";
import { Grid } from 'semantic-ui-react'
import * as modalActions from "../../actions/modalActions";


class UploadVideoComponent extends React.Component<IUploadVideoComponentProps , IUploadVideoComponentState> {

    constructor(props : IUploadVideoComponentProps) {
        super(props);
        this.state = {
            value: ".mp4 ",
            previews: [],
            accepted: [],
            img: '',
            interval: 0.1,
            seek: 0,
            offset: 0,
            numFrames: 2,
            type: '',
            percent: 0,
            youtube: '',
            title: '',
            description: '',
            tags: [],
            uploaded : false
        }
    }

    componentDidMount(){

        if (this.props.location && this.props.location.state && this.props.location.state.link)
        {
            this.generateyoutubelink(this.props.location.state.link)
        }
    }

    componentWillReceiveProps(nextProps: Readonly<IUploadVideoComponentProps>, nextContext: any): void {
        if (nextProps.location && nextProps.location.state && nextProps.location.state.link)
        {
            this.generateyoutubelink(nextProps.location.state.link)
        }
    }

    KeyCodes = {
        comma: 188,
        enter: 13,
    };

    delimiters = [this.KeyCodes.comma, this.KeyCodes.enter];

    handleDelete = (i) => {
        const { tags } = this.state;
        this.setState({
            tags: tags.filter((tag, index) => index !== i),
        });
    }

    handleAddition  = (tag) => {
        tag.text = '#'+tag.text
        if(this.state.tags.filter(t => t.text === tag.text ) == 0)

            this.setState(state => ({ tags: [...state.tags, tag] }));
    }

    handleDrag = (tag, currPos, newPos) => {
        const tags = [...this.state.tags];
        const newTags = tags.slice();

        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);
        // re-render
        this.setState({ tags: newTags });
    }

    async onSubmit() {

        if (this.props.authenticated && this.state.tags.length > 0){
            event.preventDefault()
            this.setState({uploaded : true})
            fetch(this.state.img)
                .then(res => res.blob())
                .then(blob =>  this.props.handleSubmit(this.props.user,this.state.tags,this.state.title,this.state.description,blob,this.state.text,
                    (key)=>{
                        this.props.history.push('/gif/'+key)
                        this.setState({uploaded : false})
                    }))
            await this.props.handleSubmit(this.props.user,this.state.tags,this.state.title,this.state.description,this.state.img,this.state.text,
                (key)=>{
                    this.props.history.push('/gif/'+key)
                    this.setState({uploaded : false})
                })
        } else {
            if (!this.props.authenticated )
                this.props.openLoginModal(true , ()=>{})
            else if(this.state.tags.length <=0)
                toast.info('Ajouter des tags')
        }
    }

    creategif = () => {

        if (this.state.accepted && this.state.accepted[0]) {
        event.preventDefault()
        let video, time, interval: any
        let image: any
        let images = []
            let waterMark
            (() => {
                waterMark = document.querySelector("#logogif");
            })();
        this.state.accepted.map((v, i) => {
            images.push(v.preview)
        })

        if (this.state.accepted[0].type.split('/')[0] === 'video') {
            video = images
            image = false

            interval = 0.1
        } else {
            video = false
            image = images

            interval = this.state.interval
        }
        gifshot.createGIF(
            {
                gifWidth: 400,
                gifHeight: 300,
                images: image,
               /* video: 'https://imaging.giphy.com/imaging/trim?media_url=https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3DRdSBd4TgSN8&start=0&duration=10',
               */ video: video,
                interval: interval,
                offset: this.state.offset,
                numFrames: this.state.numFrames * 10,
                frameDuration: 0.1,
                fontWeight: 'bold',
                fontSize: '40px',
                fontFamily: 'sans-serif',
                fontColor: '#FFFFFF',
                textAlign: 'center',
                textBaseline: 'bottom',
                sampleInterval: 10,
                numWorkers: 2,
                crossOrigin : "anonymous",
               /* waterMark: waterMark,
                waterMarkXCoordinate: 340,
                waterMarkYCoordinate: 240,
                waterMarkWidth:50,
                waterMarkHeight: 50,
               */ textYCoordinate: 0,
                text: this.state.text,
                progressCallback: (captureProgress) => {
                    this.setState({percent: captureProgress * 100})
                    if (captureProgress * 100 === 100 && this.state.img !== '') {
                        this.setState({percent: 0})
                    }

                },
                completeCallback: (com) => {
                    console.log(com, 'complited')
                },
            }, (obj) => {
                if (!obj.error) {
                    //   var image = obj.image, animatedImage = document.createElement('img');
                    //  animatedImage.src = image;
                    this.setState({img: obj.image, percent: 0})


                    //document.body.appendChild(animatedImage);
                }
            });}

    }

    onDrop = (accepted, rejected, links) => {

        let acc = accepted.map(v => acc = v)

        if (this.state.accepted.length > 0)
            console.log(this.state.accepted[0].type.split('/')[0])

        if (this.state.accepted.length == 0) {
            let newPreviews = [...this.state.previews, ...accepted.map(v => v.preview), ...links];

            let newAccepted = [...this.state.accepted, ...accepted.map(v => v), ...links];

            this.setState({
                previews: newPreviews,
                accepted: newAccepted,
                type: acc[0].type.split('/')[0]
            });
        }
    };

    notify = () => {
        toast("Wow so easy !");
        console.log('nooot')
    }

    generateyoutubelink = async (url: string) => {

 axios.get('https://imaging.giphy.com/fetch/video/info?url=' + encodeURIComponent(url)).then(res => {

     console.log(res)
     if (res.data.duration < 600 ){
     this.setState({
         accepted: [{preview: res.data.url , type: 'video/mp4'}],
         type: 'video'
     })}
     else {
         toast('la durée de la vidéo ne doit pas dépasser 10 minutes')

     }


 })


        /*
        let re = /^(https?:\/\/)?((www\.)?(youtube(-nocookie)?|youtube.googleapis)\.com.*(v\/|v=|vi=|vi\/|e\/|embed\/|user\/.*\/u\/\d+\/)|youtu\.be\/)([_0-9a-z-]+)/i;
        let id = url.match(re)[7];
        let res =    await fetch('https://europe-west1-ttgif-3c665.cloudfunctions.net/links?id='+id);
        res.json().then(items => {
            if (items[0].sp && items.find( a=> a.sp === 'signature') ){

                toast.error("video protégée !", {
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true
                });
            }
            else   if ( items[0].type &&  items.find( a=> a.type.includes('mp4'))   )
            {
                this.setState({
                    accepted: [{preview: items.find(a => a.type.includes('mp4')).url + '&origin=https://5c8b31010be0b70008b9e923--clever-tesla-9127eb.netlify.com', type: 'video/mp4'}],
                    type: 'video'
                })
            } else {toast.error("URL  Invalide !", {
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true
            });}
        })*/
    }

    handleChange = () => {
        let text, interval, time, seek, video, youtube, numFrames , textupload: any;
        (() => {
            text = document.querySelector("#text");
            textupload = document.querySelector("#textupload");
            interval = document.querySelector("#interval");
            seek = document.querySelector("#seek-bar");
            video = document.querySelector("#video");
            numFrames = document.querySelector("#numFrames");
            youtube = document.querySelector("#youtube");
        })();
    if(textupload)
    textupload = textupload.value
        //console.log(youtube)
        if (youtube && !video)
        {
            if(youtube.value && youtube.value.includes('watch?v')) {
                youtube= youtube.value

                this.generateyoutubelink(youtube)
            }
        }
        if (text)
            text = text.value;
        else {
            text= this.state.text
        }
        if (this.state.type === 'video' && numFrames)
            numFrames = numFrames.value

        if (this.state.type === 'video' && video) {
            time = video.duration * (seek.value / 100);

            // Update the video time
            video.currentTime = time;

            seek = (100 / video.duration) * video.currentTime;

        } else {
            time = 0
        }


        if (this.state.type !== 'video' && interval)
            interval = interval.value;
        else if (this.state.type === 'video')
            interval = 0.1;
        else
            interval = 0.5;


        this.setState({
            seek: seek,
            text: text,
            interval: interval,
            offset: time,
            numFrames: numFrames ,
            title : textupload
        });
    }

    onRemove = (file) => {
        console.log(file , 'fffffffffffffffff')
        let acc = this.state.accepted.filter(a => a !== file)

        console.log(acc)

        this.setState({
            accepted: acc
        })

        console.log(acc, 'fff')
    }

    render() {
        const {uploaded , img, accepted, type, percent} = this.state

        return (

            <div>
                <MenuLeftemobile/>
                <HeaderComponent/>
                <MenuComponent/>
                <ToastContainer />

                {!uploaded ?
                <Grid stackable style={{ margin: '0px 0px 120px 0px' , maxHeight : '400px'}} columns={2}>
                    <Grid.Column textAlign="center">
                    <div style={{
                        marginTop : '-30px',
                        minWidth: '300px',
                        maxWidth: '500px',
                        width:'90%'
                    }}>
                        {
                            img
                                ?
                                <div className='' style={{

                                    position: 'relative',
                                    width:'100%'
                                }}>

                                    <img src={this.state.img}  style={{
                                        marginTop: 50,
                                        height: 300
                                    }}/>
                                    <div className="editbtn"  style={{cursor: 'pointer'}} onClick={() => this.setState({
                                        img: ''
                                    })}>
                                        <div className="btnIcon ">
                                            <img src={icon3}/>
                                        </div>
                                    </div>
                                </div>

                                :
                                percent>0 && img === '' ?

                                    <Loader type="Plane" color="#f34c71" height={80} width={80} /> :
                                    <MagicDropzone
                                        style={{
                                            width:'100%',
                                            maxWidth:500,
                                            height: 400,
                                            minHeight : 400 ,
                                            background: 'linear-gradient(180deg, rgba(51, 114, 194, 0.8) 0%, rgba(243, 76, 113, 0.73) 100%)'

                                        }}
                                        className="Dropzone"
                                        accept={this.state.value}
                                        onDrop={this.onDrop}>
                                        <div className="Dropzone-content">
                                            {this.state.accepted.length && this.state.accepted.length > 0 ? (
                                                this.state.accepted.map((v, i) => (
                                                    <div>
                                                        {
                                                            (
                                                                v && this.state.accepted.length === 1 ?
                                                                    <div key={i} className="Dropzone-img-big"
                                                                         style={{maxWidth:'290px',maxHeight:'322px'}}
                                                                    >

                                                                        <div>
                                                                            <div onClick={() => this.onRemove(v)}
                                                                                 style={{
                                                                                    zIndex: 999,
                                                                                    width:'20px',
                                                                                    height:'20px',
                                                                                    background:'black',
                                                                                    color: 'white',
                                                                                    borderRadius: '50%',
                                                                                    opacity: 1.5,
                                                                                    position:'absolute'
                                                                                 }}><p style={{textAlign: 'center'}}>x</p>
                                                                            </div>
                                                                            < video
                                                                            controls
                                                                            controlsList="nodownload noremoteplayback nofullscreen"
                                                                            className="Dropzone-img-big"
                                                                            src={v.preview} id="video"
                                                                            onChange={this.handleChange}></video>
                                                                        </div>
                                                                    </div> :
                                                                    v ?
                                                                        <div key={i}>
                                                                            <div onClick={() => this.onRemove(v)}
                                                                                 style={{
                                                                                     float: 'right',
                                                                                     backgroundColor: '#999999',
                                                                                     color: 'white',
                                                                                     borderRadius: '40%',
                                                                                     pading: '5px',
                                                                                     opacity: 0.3
                                                                                 }}><p style={{margin: '5px'}}>x</p>
                                                                            </div>
                                                                            <img className="Dropzone-img"
                                                                                 src={v.preview}/>
                                                                        </div> :
                                                                        null
                                                            )
                                                        }
                                                    </div>

                                                ))
                                            ) : (
                                                "Déposez quelques fichiers sur moi!"

                                            )}
                                        </div>
                                    </MagicDropzone>
                        }
                    </div>
                    </Grid.Column>
                    <Grid.Column >
                    <div style={{
                        minWidth: '300px',
                        maxWidth: '500px',
                        width:'90%',
                    }}>

                        {
                            !img ?
                                <form style={{
                                    height: 400,
                                    minHeight: 400,
                                    background: 'linear-gradient(180deg, rgba(51, 114, 194, 0.8) 0%, rgba(243, 76, 113, 0.73) 100%)',
                                    marginTop: '12px',
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                    marginBottom : '150px'
                                }}>
                                    <p style={{
                                        fontFamily: 'Gotham_Bold',
                                        lineHeight: 'normal',
                                        fontSize: '20px',
                                        color: 'white',
                                        paddingTop: '4px',
                                        paddingLeft: '21px',
                                        marginBottom: '5px',
                                        width:'90%'
                                        //height:'15px'
                                        // paddingBottom : '5px'
                                    }}>

                                        Paramètres du diaporama
                                    </p>
                                    <p    style={{
                                        fontFamily: 'Gotham_Bold',
                                        lineHeight: 'normal',
                                        fontSize: '14.2px',
                                        color: 'white',
                                        paddingLeft: '21px',
                                        width: '90%',

                                        //padding : '1'

                                    }}>Ajouter ou supprimer une vidéo et réorganiser pour créer votre diaporama

                                    </p>
                                    <div  style={{


                                        height: '35px',
                                        paddingLeft: '21px',
                                        marginTop: '15px',
                                        width:'90%'
                                    }}>
                                        <input
                                            style={{
                                                width: '100%',
                                                height : '100%',
                                                paddingLeft: '21px',
                                            }}
                                            placeholder='Ajouter du texte à afficher sur le GIF' type="text" value={this.state.text} id='text'
                                            onChange={this.handleChange}/>
                                    </div>

                                    <div style={{
                                        paddingLeft: '21px',
                                        marginTop: '10px',
                                        width:'90%'
                                    }}>
                                    <div style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            fontFamily: 'Gotham_Bold',
                                            lineHeight: 'normal',
                                            fontSize: '16px',
                                            color: 'white',
                                            justifyContent: 'space-between',
                                            marginTop: '10px',
                                            width: '100%'
                                        }}>
                                    <p style={{marginBottom: 0}} >TEMPS DE DÉBUT</p>

                                    <div style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                justifyContent: 'flex-end'

                                            }}>
                                                <p style={{
                                                fontSize:  '72%',
                                                }}>Secondes :</p>
                                                <input type="number"
                                                       value={this.state.offset.toFixed(1)} min="0"
                                                       onChange={this.handleChange}
                                                       style={{
                                                           width: '20%',
                                                           height: '29px',
                                                           paddingLeft : '4px'

                                                       }}/>
                                            </div>
                                        </div>

                                    </div>

                                    <input type="range" style={{
                                        marginTop: '5px',
                                        marginLeft: '21px'
                                    }} id="seek-bar" value={Math.floor(this.state.seek)} min="0.0"
                                           onChange={this.handleChange}/>
                                    <div style={{
                                        paddingLeft: '21px',
                                        marginTop: '10px'


                                    }}>
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            fontFamily: 'Gotham_Bold',
                                            lineHeight: 'normal',
                                            fontSize: '16px',
                                            color: 'white',
                                            justifyContent: 'space-between',
                                            marginTop: '10px',
                                            width:'90%'


                                        }}>
                                            <p> DURÉE</p>

                                            <div style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems : 'center',
                                                justifyContent: 'flex-end'
                                            }}>
                                                <p style={{
                                                    fontSize:  '72%',

                                                }}>Secondes :</p>
                                                <input type="number"
                                                       value={this.state.numFrames} min="0" max="5"
                                                       onChange={this.handleChange}
                                                       step="0.1"

                                                       style={{
                                                           paddingLeft : '4px',
                                                           width: '37%',
                                                           height: '29px'

                                                       }}/>
                                            </div>
                                        </div>
                                        <input type="range" style={{
                                            marginTop: '5px',
                                            width: '90%'
                                        }} id="numFrames" value={this.state.numFrames} step="0.1" min="0.0" max="5.0"
                                               onChange={this.handleChange}/>
                                    </div>
                                     <div className="btn"
                                         style={{
                                             float: 'right',
                                             width: '40% ',
                                             paddingRight: '10px',
                                             paddingLeft: '21px',
                                             marginTop: '5px',
                                             cursor: 'pointer',
                                             marginRight : '28px'
                                         }}
                                         onClick={() => this.creategif()}>
                                        <div className="btnIcon"><img src={icon2}/></div>
                                        <div className="btninsideContainer">
                                            <div className="firstTitle">APERÇU</div>
                                            {/*    <div className="secondTitle">Upload PICTURES from your device</div>
                            */}
                                        </div>
                                    </div>
                                    {
                                        percent > 0 && img === '' ?
                                            <div>

                                                <h1 style={{
                                                    width: '60%',
                                                    marginLeft: '45%',
                                                    marginTop: '0%'
                                                }}> {Math.floor(percent)}%
                                                </h1>
                                            </div>
                                            :
                                            null
                                    }
                                </form>  :


                                <form style={{

                                    minWidth: '300px',
                                    maxWidth: '500px',
                                    width:'90%',
                                    height: 328,
                                    background: 'linear-gradient(180deg, rgba(51, 114, 194, 0.8) 0%, rgba(243, 76, 113, 0.73) 100%)',
                                    marginTop: '12px',
                                    marginBottom: '150px'


                                }}>

                                    <div className="" style={{


                                        height: '35px',
                                        paddingLeft: '21px',
                                        marginTop: '15px'

                                    }}>
                                        <input
                                            style={{

                                                width: '90%',
                                                height: '100%',
                                                paddingLeft: '21px',
                                                marginTop: '25px'
                                            }}

                                            placeholder='Ajouter un titre au GIF' type="text" value={this.state.title} id='textupload'
                                            onChange={this.handleChange}/>
                                    </div>

                                    <ReactTags
                                        tags={this.state.tags}
                                        handleDelete={this.handleDelete}
                                        handleAddition={this.handleAddition}
                                        handleDrag={this.handleDrag}
                                        delimiters={this.delimiters}
                                        inline={false}
                                        placeholder={ 'Cliquez sur entrée pour ajouter un nouveau tag'}
                                        classNames={{
                                            remove: 'removeClass2',
                                            tagInput: 'inputTags',
                                            selected: 'selectedClass btn',
                                            tag:'tagClass'

                                        }}

                                        style={{
                                            marginTop : '40px'

                                        }}

                                    />

                                    <div className="btn"
                                         style={{

                                             width: '80% ',
                                             paddingRight: '10px',
                                             paddingLeft: '21px',
                                             marginLeft: '45px',
                                             marginTop: '25px',
                                             cursor: 'pointer'

                                         }}
                                         onClick={ () => this.onSubmit()}>
                                        <div className="btnIcon"><img src={icon2}/></div>
                                        <div className="btninsideContainer">
                                            <div className="firstTitle">PUBLIER</div>

                                        </div>
                                    </div>
                                </form>


                        }
                    </div>
                    </Grid.Column>
                    </Grid> :
                    <Loader type="Plane" color="#f34c71" height={80} width={80} />

                }
                <FooterComponent/>
            </div>
        );
    }


}


function mapsStateToProps(state) {
    return {
        errorMessage: state.auth.errorMessage,
        authenticated: state.auth.authenticated,
        user: state.auth.currentUser,
        newGif : state.Gif,
    };
}

const mapDispatchToProps = (dispatch: any, ownProps: IUploadGifComponentProps)=>{
    return {
        handleSubmit: (user,tags, title,description,file ,text, cb ) =>dispatch( gifActions.onSubmit(user,tags, title,description,file , text,cb)),
        openLoginModal: (type , cb) => dispatch(modalActions.loginModal(type, cb)),

    }
}

export default connect(mapsStateToProps , mapDispatchToProps) (withRouter(UploadVideoComponent))



// WEBPACK FOOTER //
// ./src/components/uploadVideoComponent/UploadVideoComponent.tsx